'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useId, useState } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { AnimatedSwitch } from '@/components/ui/animated-switch';
import { AppTooltip } from '@/components/ui/app-tooltip';
import { SlidersVerticalIcon } from '@/components/ui/icon/glyphs';
import { SilkSheet } from '@/components/ui/silk-sheet';
import { useAllowRapidTrades } from '@/hooks/use-allow-rapid-trades';
import { useTradeSettingsStore } from '@/stores/trade-settings';
export function TradeSettingsDialog() {
  const $ = _c(46);
  const t = useTranslations("trade");
  const [open, setOpen] = useState(false);
  const switchId = useId();
  const descriptionId = useId();
  const allowRapidTrades = useAllowRapidTrades();
  const setAllowRapidTrades = useTradeSettingsStore(_temp);
  let t0;
  if ($[0] !== t) {
    t0 = t("settings.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <p className="text-caption">{t0}</p>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("settings.title");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpen(true);
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== open || $[8] !== t2) {
    t4 = <AnimatedButton type="button" variant="tertiary" size="lg" prefix={SlidersVerticalIcon} aria-label={t2} aria-haspopup="dialog" aria-expanded={open} onClick={t3} />;
    $[7] = open;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <AppTooltip content={t1} side="top">{t4}</AppTooltip>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("settings.title");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t("settings.description");
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("settings.rapid_trades_label");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== switchId || $[20] !== t8) {
    t9 = <label htmlFor={switchId}>{t8}</label>;
    $[19] = switchId;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== allowRapidTrades || $[23] !== descriptionId || $[24] !== setAllowRapidTrades || $[25] !== switchId) {
    t10 = <AnimatedSwitch id={switchId} size="sm" checked={allowRapidTrades} onCheckedChange={setAllowRapidTrades} aria-describedby={descriptionId} />;
    $[22] = allowRapidTrades;
    $[23] = descriptionId;
    $[24] = setAllowRapidTrades;
    $[25] = switchId;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t9) {
    t11 = <div className="flex items-center justify-between gap-2 text-body">{t9}{t10}</div>;
    $[27] = t10;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t) {
    t12 = t("settings.rapid_trades_description");
    $[30] = t;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== descriptionId || $[33] !== t12) {
    t13 = <p id={descriptionId} className="text-caption text-foreground-secondary">{t12}</p>;
    $[32] = descriptionId;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t11 || $[36] !== t13) {
    t14 = <div className="flex w-full flex-col gap-4"><div className="flex flex-col gap-2">{t11}{t13}</div></div>;
    $[35] = t11;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== open || $[39] !== t14 || $[40] !== t6 || $[41] !== t7) {
    t15 = <SilkSheet open={open} onOpenChange={setOpen} variant="detached" size="sm" title={t6} description={t7}>{t14}</SilkSheet>;
    $[38] = open;
    $[39] = t14;
    $[40] = t6;
    $[41] = t7;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== t15 || $[44] !== t5) {
    t16 = <>{t5}{t15}</>;
    $[43] = t15;
    $[44] = t5;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  return t16;
}
function _temp(s) {
  return s.setAllowRapidTrades;
}